import { componentTypes, Schema } from '@data-driven-forms/react-form-renderer';
import { GridProps } from '@mui/system';
import { Perk } from '../../interface/interface';

export interface PerkSchemaData {
  title: string,
  description: string,
  editData?: Perk,
}

// xs, sm, md, lg, xl: Define the number of grid columns the item should span at different breakpoints (e.g., xs: 6 means the item spans 6 out of 12 columns on extra-small screens).
// spacing: Defines the space between grid items.
//   alignItems: Aligns items vertically (e.g., flex-start, center, flex-end).
//   justifyContent: Aligns items horizontally (e.g., flex-start, center, space-between).
//   direction: Defines the direction of the grid (e.g., row, column).
export const PerkSchema = (props: PerkSchemaData) => {
  console.log(props, 'props');
  const {
    editData,
  } = props;
  return {
    fields: [
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Title',
        placeholder: 'Perk Title',
        name: 'title',
        required: true,
        disabled: false,
        FormFieldGridProps: { xs: 12 },
        initialValue: editData?.title,
        validate: [{
          type: 'required',
          message: 'Perk title is required'
        }]
      },
      {
        component: componentTypes.TEXTAREA,
        label: 'Description',
        placeholder: 'Perk Description',
        name: 'description',
        required: true,
        disabled: false,
        rows: 4,
        FormFieldGridProps: { xs: 12 },
        initialValue: editData?.description,
        validate: [{
          type: 'required',
          message: 'Perk description is required'
        }]
      }
    ]
  } as Schema extends GridProps ? GridProps : never;
};
